var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-set-tag",
      attrs: {
        title: _vm.popTitle,
        visible: _vm.visibleDialog,
        width: "424px",
        top: "calc(50vh - 140px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "radio-group",
          model: {
            value: _vm.radio,
            callback: function ($$v) {
              _vm.radio = $$v
            },
            expression: "radio",
          },
        },
        _vm._l(_vm.radioList, function (item, index) {
          return _c(
            "el-radio",
            {
              key: index,
              attrs: { label: item.tagId },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.changeTag(item.tagId)
                },
              },
            },
            [_c("span", { class: "tag-no tag-" + item.tagId })]
          )
        }),
        1
      ),
      _c(
        "el-checkbox-group",
        {
          staticClass: "checkbox-group",
          model: {
            value: _vm.check,
            callback: function ($$v) {
              _vm.check = $$v
            },
            expression: "check",
          },
        },
        _vm._l(_vm.checkList, function (item, index) {
          return _c(
            "el-checkbox",
            { key: index, attrs: { label: item.tagId } },
            [
              _vm._v(_vm._s(item.tagName)),
              item.tagOrderType == 2
                ? _c("span", { staticClass: "i-yichang" })
                : _vm._e(),
            ]
          )
        }),
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }